import React from 'react'
import { graphql } from 'gatsby'

import PageHeader from '../components/PageHeader'
import Content from '../components/Content.js'
import Layout from '../components/Layout.js'
import Gallery from '../components/Gallery'

// Export Template for use in CMS preview
export const ServicosPageTemplate = ({
  title,
  subtitle,
  featuredImage,
  body,
  gallery
}) => (
  <main>
    <PageHeader
      title={title}
      subtitle={subtitle}
      backgroundImage={featuredImage}
    />

    <section className="section">
      <div className="container">
          <Content source={body} />
      </div>
    </section>

    <section className="section">
      <div className="container">
        <h3>Exemplos de tabelas</h3>
        <Gallery images={gallery} />
      </div>
    </section>

  </main>
)

const ServicosPage = ({ data: { page } }) => (
  <Layout
    meta={page.frontmatter.meta || false}
    title={page.frontmatter.title || false}
  >
    <ServicosPageTemplate {...page} {...page.frontmatter} body={page.html} />
  </Layout>
)

export default ServicosPage

export const pageQuery = graphql`
  query ServicosPage($id: String!) {
    page: markdownRemark(id: { eq: $id }) {
      ...Meta
      ...Gallery
      html
      frontmatter {
        title
        template
        subtitle
        featuredImage
      }
    }
  }
`
